import React from 'react'
import styles from './styles.module.css'

const MenuDivider = () => <div className={styles.menuDivider} />

export default MenuDivider
